export default __webpack_public_path__ + "static/applicazioni-cross-platform-vantaggi-per-aziende-orangeloop-576c3b6ea57a09d7c07b663879849c28.jpg";